var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProgressBar'),_c('PageHeading',{attrs:{"default-heading":_vm.pd_content.page_header}}),_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"pvd-container container-divider"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pd_content.confirmation_text)}})]),_c('NavigationComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }